export const SET_AGREEMENT_DATA = 'SET_AGREEMENT_DATA'
export const SET_DOCUMENTS_OPTIONS = 'SET_DOCUMENTS_OPTIONS'
export const SET_DOCUMENTS_FOR_TABLE = 'SET_DOCUMENTS_FOR_TABLE'
export const SET_LOADER_TRUE = 'SET_LOADER_TRUE'
export const SET_LOADER_FALSE = 'SET_LOADER_FALSE'
export const CHANGE_AGREEMENT_DATA = 'CHANGE_AGREEMENT_DATA'
export const CHANGE_SELECTED_FIELDS = 'CHANGE_SELECTED_FIELDS'
export const SET_SELECTED_FIELDS = 'SET_SELECTED_FIELDS'
export const SET_MANAGER_EMAIL = 'SET_MANAGER_EMAIL'
